var _style, _defs, _ellipse, _g, _path, _polygon, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon2, _circle, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterLogoRami(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 232.1 302",
    style: {
      enableBackground: "new 0 0 232.1 302"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000152258806802891249240000007494919150457770687_);fill:#FFFFFF;stroke:#211E1F;stroke-width:0.3352;stroke-miterlimit:10;}\n\t.st1{clip-path:url(#SVGID_00000152258806802891249240000007494919150457770687_);fill:#5AA6BF;}\n\t.st2{clip-path:url(#SVGID_00000152258806802891249240000007494919150457770687_);fill:#49B7E7;}\n\t.st3{clip-path:url(#SVGID_00000152258806802891249240000007494919150457770687_);fill:#5FC4BE;}\n\t.st4{clip-path:url(#SVGID_00000152258806802891249240000007494919150457770687_);fill:#5DC0A0;}\n\t.st5{clip-path:url(#SVGID_00000152258806802891249240000007494919150457770687_);fill:#00B694;}\n\t.st6{clip-path:url(#SVGID_00000152258806802891249240000007494919150457770687_);fill:#BB2028;}\n\t.st7{clip-path:url(#SVGID_00000152258806802891249240000007494919150457770687_);fill:#CCDC54;}\n\t.st8{clip-path:url(#SVGID_00000152258806802891249240000007494919150457770687_);fill:#EBB71E;}\n\t.st9{clip-path:url(#SVGID_00000152258806802891249240000007494919150457770687_);fill:#E68425;}\n\t.st10{clip-path:url(#SVGID_00000152258806802891249240000007494919150457770687_);fill:#E92032;}\n\t.st11{fill:#FFFFFF;}\n\t.st12{fill:#E92032;}\n\t.st13{fill:none;stroke:#FFFFFF;stroke-width:1.1039;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#000000;stroke-width:0.5403;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_1_",
    cx: 115.8,
    cy: 118.6,
    rx: 95.7,
    ry: 95.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000035526980168709413660000005787034455839125925_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 7.2,
    y: 17.9,
    style: {
      clipPath: "url(#SVGID_00000035526980168709413660000005787034455839125925_)",
      fill: "#FFFFFF",
      stroke: "#211E1F",
      strokeWidth: 0.3352,
      strokeMiterlimit: 10
    },
    width: 215.2,
    height: 201.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.2,
    y: 17.9,
    style: {
      clipPath: "url(#SVGID_00000035526980168709413660000005787034455839125925_)",
      fill: "#5AA6BF"
    },
    width: 21.8,
    height: 201.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 17.9,
    style: {
      clipPath: "url(#SVGID_00000035526980168709413660000005787034455839125925_)",
      fill: "#49B7E7"
    },
    width: 21.8,
    height: 201.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.4,
    y: 17.9,
    style: {
      clipPath: "url(#SVGID_00000035526980168709413660000005787034455839125925_)",
      fill: "#5FC4BE"
    },
    width: 21.8,
    height: 201.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.2,
    y: 17.9,
    style: {
      clipPath: "url(#SVGID_00000035526980168709413660000005787034455839125925_)",
      fill: "#5DC0A0"
    },
    width: 21.8,
    height: 201.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.6,
    y: 17.9,
    style: {
      clipPath: "url(#SVGID_00000035526980168709413660000005787034455839125925_)",
      fill: "#00B694"
    },
    width: 21.8,
    height: 201.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 17.9,
    style: {
      clipPath: "url(#SVGID_00000035526980168709413660000005787034455839125925_)",
      fill: "#BB2028"
    },
    width: 21.8,
    height: 201.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.9,
    y: 17.9,
    style: {
      clipPath: "url(#SVGID_00000035526980168709413660000005787034455839125925_)",
      fill: "#CCDC54"
    },
    width: 21.8,
    height: 201.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.7,
    y: 17.9,
    style: {
      clipPath: "url(#SVGID_00000035526980168709413660000005787034455839125925_)",
      fill: "#EBB71E"
    },
    width: 21.8,
    height: 201.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.6,
    y: 17.9,
    style: {
      clipPath: "url(#SVGID_00000035526980168709413660000005787034455839125925_)",
      fill: "#E68425"
    },
    width: 21.8,
    height: 201.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.5,
    y: 17.9,
    style: {
      clipPath: "url(#SVGID_00000035526980168709413660000005787034455839125925_)",
      fill: "#E92032"
    },
    width: 21.8,
    height: 201.8
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.8,
    cy: 119.1,
    rx: 81.8,
    ry: 81.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "91.8,126.5 96.2,132.2 103.8,121.8 109.6,121.8 109.6,102  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 102,
    className: "st11",
    width: 7,
    height: 30.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.4,
    y: 102,
    className: "st11",
    width: 7,
    height: 30.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "129.4,132.7 122.4,132.7 122.4,106.6 129.4,113.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "143.4,132.7 150.4,132.7 150.4,106.6 143.5,113.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "122.4,102 130.1,102 136.2,109.7 142.8,102 150.4,102 150.4,104.7 136.2,118.9 122.4,104.7  "
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M77.4,109.4l17.7,23h-9l-15.8-20.2V102H85c0,0,7.9,0.4,8.6,9.9c0,0,0.5,7-5.4,9.7l-5.1-6.5 c0,0,2.8,0.5,2.8-2.8c0,0,0-2.8-2.6-3H77.4"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "70.3,113.8 77.4,122.9 77.5,132.5 70.3,132.5  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M70.3,141.3c0-0.6,0.1-1.1,0.2-1.6c0.2-0.5,0.4-0.9,0.7-1.3c0.3-0.4,0.7-0.6,1.1-0.8 c0.4-0.2,0.9-0.3,1.5-0.3c0.4,0,0.8,0.1,1.1,0.2c0.3,0.1,0.6,0.3,0.8,0.4c0.2,0.2,0.4,0.4,0.5,0.6c0.1,0.2,0.2,0.4,0.3,0.6 c0.1,0.2,0.1,0.3,0.2,0.5c0,0.1,0,0.2,0,0.2h-0.5c0-0.3-0.1-0.6-0.3-0.9c-0.2-0.3-0.3-0.5-0.6-0.6c-0.2-0.2-0.5-0.3-0.8-0.4 c-0.3-0.1-0.6-0.1-0.9-0.1c-0.5,0-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.4-1,0.8c-0.3,0.3-0.5,0.7-0.6,1.1c-0.1,0.4-0.2,0.9-0.2,1.4 c0,0.5,0.1,1,0.2,1.4c0.1,0.4,0.3,0.8,0.6,1.1c0.3,0.3,0.6,0.6,1,0.8c0.4,0.2,0.8,0.3,1.3,0.3c0.4,0,0.7-0.1,1-0.2 c0.3-0.2,0.6-0.4,0.8-0.6c0.2-0.3,0.4-0.5,0.6-0.9c0.1-0.3,0.2-0.7,0.2-1H77c0,0.5-0.2,0.9-0.3,1.3c-0.2,0.4-0.4,0.7-0.7,1 c-0.3,0.3-0.6,0.5-1,0.7c-0.4,0.2-0.7,0.2-1.2,0.2c-0.6,0-1.1-0.1-1.5-0.3c-0.4-0.2-0.8-0.5-1.1-0.8c-0.3-0.4-0.5-0.8-0.7-1.3 C70.4,142.4,70.3,141.9,70.3,141.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M79.4,137.5h0.5v7.6h-0.5V137.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M82.6,137.5h0.6l4.7,7h0v-7h0.5v7.6h-0.5l-4.8-7h0v7h-0.5V137.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M90.2,137.9v-0.4H96v0.4h-2.6v7.2h-0.5v-7.2H90.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M99.3,137.5h0.5l3,7.6h-0.5l-0.9-2.4h-3.6l-1,2.4h-0.5L99.3,137.5z M101.2,142.3l-1.6-4.3h0l-1.7,4.3H101.2z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M109.5,139.7c0-0.3-0.1-0.6-0.2-0.9c-0.1-0.2-0.3-0.4-0.5-0.6c-0.2-0.2-0.5-0.3-0.7-0.4 c-0.3-0.1-0.6-0.1-0.9-0.1c-0.2,0-0.4,0-0.7,0.1c-0.2,0-0.5,0.1-0.7,0.3c-0.2,0.1-0.4,0.3-0.5,0.5c-0.1,0.2-0.2,0.5-0.2,0.8 c0,0.3,0.1,0.6,0.2,0.7c0.1,0.2,0.3,0.3,0.6,0.5c0.2,0.1,0.5,0.2,0.8,0.3c0.3,0.1,0.6,0.1,0.9,0.2c0.3,0.1,0.6,0.1,0.9,0.2 c0.3,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.4,0.4,0.6,0.6c0.1,0.2,0.2,0.6,0.2,0.9c0,0.4-0.1,0.7-0.3,1c-0.2,0.3-0.4,0.5-0.6,0.7 c-0.3,0.2-0.5,0.3-0.8,0.4c-0.3,0.1-0.6,0.1-0.9,0.1c-0.4,0-0.9,0-1.2-0.1c-0.4-0.1-0.7-0.3-1-0.5c-0.3-0.2-0.5-0.5-0.7-0.8 s-0.2-0.8-0.2-1.2h0.5c0,0.4,0,0.8,0.2,1.1c0.1,0.3,0.3,0.5,0.6,0.7c0.2,0.2,0.5,0.3,0.9,0.4c0.3,0.1,0.7,0.1,1.1,0.1 c0.2,0,0.5,0,0.7-0.1c0.3-0.1,0.5-0.2,0.7-0.3c0.2-0.1,0.4-0.3,0.5-0.5c0.1-0.2,0.2-0.5,0.2-0.8c0-0.3-0.1-0.6-0.2-0.8 c-0.1-0.2-0.3-0.4-0.6-0.5c-0.2-0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.6-0.1-0.9-0.2c-0.3-0.1-0.6-0.1-0.9-0.2c-0.3-0.1-0.6-0.2-0.8-0.3 c-0.2-0.1-0.4-0.3-0.6-0.6c-0.1-0.2-0.2-0.5-0.2-0.9s0.1-0.7,0.2-0.9c0.2-0.3,0.3-0.5,0.6-0.6c0.2-0.2,0.5-0.3,0.8-0.4 c0.3-0.1,0.6-0.1,0.9-0.1c0.4,0,0.8,0,1.1,0.1c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.2,0.5,0.4,0.6,0.7c0.2,0.3,0.2,0.7,0.3,1.1H109.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M122.1,141.9v1.1H120v2.1h-1.1V143h-2.1v-1.1h2.1v-2.1h1.1v2.1H122.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M129,137.5h0.5v3.5h4.8v-3.5h0.5v7.6h-0.5v-3.8h-4.8v3.8H129V137.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M137.4,137.5h0.5v7.6h-0.5V137.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M140.6,137.5h0.5v7.2h4.2v0.4h-4.7V137.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M153.6,141.3c0,0.6-0.1,1.1-0.2,1.6c-0.2,0.5-0.4,0.9-0.7,1.3c-0.3,0.4-0.7,0.6-1.1,0.8 c-0.4,0.2-0.9,0.3-1.5,0.3c-0.6,0-1.1-0.1-1.5-0.3c-0.4-0.2-0.8-0.5-1.1-0.8c-0.3-0.4-0.5-0.8-0.7-1.3c-0.2-0.5-0.2-1-0.2-1.6 c0-0.6,0.1-1.1,0.2-1.6c0.2-0.5,0.4-0.9,0.7-1.3c0.3-0.4,0.7-0.6,1.1-0.8c0.4-0.2,0.9-0.3,1.5-0.3c0.6,0,1.1,0.1,1.5,0.3 c0.4,0.2,0.8,0.5,1.1,0.8c0.3,0.4,0.5,0.8,0.7,1.3C153.5,140.2,153.6,140.8,153.6,141.3z M146.9,141.3c0,0.5,0.1,1,0.2,1.4 c0.1,0.4,0.3,0.8,0.6,1.1c0.3,0.3,0.6,0.6,1,0.8c0.4,0.2,0.8,0.3,1.3,0.3c0.5,0,0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.4,1-0.8 c0.3-0.3,0.5-0.7,0.6-1.1c0.1-0.4,0.2-0.9,0.2-1.4c0-0.5-0.1-1-0.2-1.4c-0.1-0.4-0.3-0.8-0.6-1.1c-0.3-0.3-0.6-0.6-1-0.8 c-0.4-0.2-0.8-0.3-1.3-0.3c-0.5,0-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.4-1,0.8c-0.3,0.3-0.5,0.7-0.6,1.1 C147,140.4,146.9,140.8,146.9,141.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M160.8,139.7c0-0.3-0.1-0.6-0.2-0.9c-0.1-0.2-0.3-0.4-0.5-0.6c-0.2-0.2-0.5-0.3-0.7-0.4 c-0.3-0.1-0.6-0.1-0.9-0.1c-0.2,0-0.4,0-0.7,0.1c-0.2,0-0.5,0.1-0.7,0.3c-0.2,0.1-0.4,0.3-0.5,0.5c-0.1,0.2-0.2,0.5-0.2,0.8 c0,0.3,0.1,0.6,0.2,0.7c0.1,0.2,0.3,0.3,0.6,0.5c0.2,0.1,0.5,0.2,0.8,0.3c0.3,0.1,0.6,0.1,0.9,0.2c0.3,0.1,0.6,0.1,0.9,0.2 c0.3,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.4,0.4,0.6,0.6c0.1,0.2,0.2,0.6,0.2,0.9c0,0.4-0.1,0.7-0.3,1c-0.2,0.3-0.4,0.5-0.6,0.7 c-0.3,0.2-0.5,0.3-0.8,0.4c-0.3,0.1-0.6,0.1-0.9,0.1c-0.4,0-0.9,0-1.2-0.1c-0.4-0.1-0.7-0.3-1-0.5c-0.3-0.2-0.5-0.5-0.7-0.8 c-0.2-0.3-0.2-0.8-0.2-1.2h0.5c0,0.4,0,0.8,0.2,1.1c0.1,0.3,0.3,0.5,0.6,0.7c0.2,0.2,0.5,0.3,0.9,0.4c0.3,0.1,0.7,0.1,1.1,0.1 c0.2,0,0.5,0,0.7-0.1s0.5-0.2,0.7-0.3c0.2-0.1,0.4-0.3,0.5-0.5c0.1-0.2,0.2-0.5,0.2-0.8c0-0.3-0.1-0.6-0.2-0.8 c-0.1-0.2-0.3-0.4-0.6-0.5c-0.2-0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.6-0.1-0.9-0.2c-0.3-0.1-0.6-0.1-0.9-0.2c-0.3-0.1-0.6-0.2-0.8-0.3 c-0.2-0.1-0.4-0.3-0.6-0.6c-0.1-0.2-0.2-0.5-0.2-0.9s0.1-0.7,0.2-0.9c0.2-0.3,0.3-0.5,0.6-0.6c0.2-0.2,0.5-0.3,0.8-0.4 c0.3-0.1,0.6-0.1,0.9-0.1c0.4,0,0.8,0,1.1,0.1c0.3,0.1,0.6,0.2,0.9,0.4c0.3,0.2,0.5,0.4,0.6,0.7c0.2,0.3,0.2,0.7,0.3,1.1H160.8z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "70.3,114.1 77.5,123.2 77.5,132.8 70.4,132.8  "
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 116,
    cy: 118.1,
    r: 95.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 66.3,
    y: 240.1,
    width: 6.7,
    height: 26.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.1,
    y: 240.1,
    width: 6.7,
    height: 26.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.3,
    y: 240.1,
    width: 6.7,
    height: 26.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.7,
    y: 240.1,
    width: 6.7,
    height: 26.5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.8,240.1 90.4,240.1 80.7,252.9 73.3,252.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.2,240.1 132.2,240.1 112,266.6 112,255.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.9,253.9 73.3,253.9 83,266.6 90.4,266.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "158,238.5 153.8,243.3 161.6,252.9 168.9,252.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "161.3,253.9 168.9,253.9 158,267.6 153.5,263.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.4,
    y: 240.1,
    width: 10.5,
    height: 5.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.4,
    y: 250.3,
    width: 6.4,
    height: 5.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.4,
    y: 260.9,
    width: 10.5,
    height: 5.7
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.8,277.7c0-0.5,0.1-0.9,0.2-1.3c0.1-0.4,0.3-0.7,0.6-1c0.3-0.3,0.6-0.5,0.9-0.7c0.4-0.2,0.8-0.3,1.3-0.3 c0.4,0,0.7,0,1,0.1c0.3,0.1,0.5,0.2,0.7,0.4c0.2,0.1,0.3,0.3,0.5,0.5c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.1,0.1,0.3,0.1,0.4 c0,0.1,0,0.2,0,0.2h-0.4c0-0.3-0.1-0.5-0.3-0.7c-0.1-0.2-0.3-0.4-0.5-0.5c-0.2-0.1-0.4-0.3-0.6-0.3c-0.2-0.1-0.5-0.1-0.8-0.1 c-0.4,0-0.8,0.1-1.1,0.2c-0.3,0.2-0.6,0.4-0.8,0.6c-0.2,0.3-0.4,0.6-0.5,0.9c-0.1,0.4-0.2,0.7-0.2,1.1c0,0.4,0.1,0.8,0.2,1.1 c0.1,0.4,0.3,0.7,0.5,0.9c0.2,0.3,0.5,0.5,0.8,0.6c0.3,0.2,0.7,0.2,1.1,0.2c0.3,0,0.6-0.1,0.9-0.2c0.3-0.1,0.5-0.3,0.7-0.5 c0.2-0.2,0.4-0.4,0.5-0.7c0.1-0.3,0.2-0.6,0.2-0.8h0.4c0,0.4-0.1,0.7-0.3,1c-0.1,0.3-0.3,0.6-0.6,0.8c-0.2,0.2-0.5,0.4-0.8,0.5 c-0.3,0.1-0.6,0.2-1,0.2c-0.5,0-0.9-0.1-1.3-0.3c-0.4-0.2-0.7-0.4-0.9-0.7c-0.3-0.3-0.4-0.6-0.6-1 C65.9,278.6,65.8,278.2,65.8,277.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2,274.6h0.4v6.3h-0.4V274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6,274.6h0.5l4,5.7h0v-5.7h0.4v6.3H82l-4-5.8h0v5.8h-0.4V274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8,274.9v-0.3h4.8v0.3h-2.2v5.9H87v-5.9H84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1,274.6h0.4l2.5,6.3h-0.4l-0.8-2h-3l-0.8,2h-0.4L93.1,274.6z M94.7,278.5l-1.3-3.5h0l-1.4,3.5H94.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,276.4c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.2-0.4-0.4-0.5c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.5-0.1-0.8-0.1 c-0.2,0-0.4,0-0.6,0.1c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.2,0.4-0.2,0.6c0,0.3,0.1,0.5,0.2,0.6 c0.1,0.2,0.3,0.3,0.5,0.4c0.2,0.1,0.4,0.2,0.7,0.2c0.3,0.1,0.5,0.1,0.8,0.2c0.3,0.1,0.5,0.1,0.8,0.2c0.3,0.1,0.5,0.2,0.7,0.3 c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.2,0.5,0.2,0.8c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.4,0.2-0.7,0.3 c-0.3,0.1-0.5,0.1-0.8,0.1c-0.4,0-0.7,0-1-0.1c-0.3-0.1-0.6-0.2-0.8-0.4c-0.2-0.2-0.4-0.4-0.6-0.7c-0.1-0.3-0.2-0.6-0.2-1h0.4 c0,0.3,0,0.6,0.1,0.9c0.1,0.2,0.3,0.4,0.5,0.6c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0.1,0.6,0.1,0.9,0.1c0.2,0,0.4,0,0.6-0.1 c0.2,0,0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.3,0.4-0.4c0.1-0.2,0.2-0.4,0.2-0.7c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.2-0.3-0.3-0.5-0.4 c-0.2-0.1-0.4-0.2-0.7-0.2c-0.3-0.1-0.5-0.1-0.8-0.2c-0.3-0.1-0.5-0.1-0.8-0.2c-0.3-0.1-0.5-0.2-0.7-0.3c-0.2-0.1-0.4-0.3-0.5-0.5 c-0.1-0.2-0.2-0.4-0.2-0.7c0-0.3,0.1-0.6,0.2-0.8c0.1-0.2,0.3-0.4,0.5-0.5c0.2-0.1,0.4-0.2,0.7-0.3c0.3-0.1,0.5-0.1,0.7-0.1 c0.3,0,0.6,0,0.9,0.1c0.3,0.1,0.5,0.2,0.7,0.3c0.2,0.2,0.4,0.4,0.5,0.6c0.1,0.2,0.2,0.5,0.2,0.9H102.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.1,274.6h0.4l2.5,6.3h-0.4l-0.8-2h-3l-0.8,2h-0.4L112.1,274.6z M113.7,278.5l-1.3-3.5h0l-1.4,3.5H113.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.4,274.6h2.1c0.6,0,1,0.1,1.4,0.3c0.4,0.2,0.7,0.4,0.9,0.7c0.2,0.3,0.4,0.6,0.5,1c0.1,0.4,0.1,0.8,0.1,1.2 c0,0.4-0.1,0.9-0.2,1.2c-0.1,0.4-0.3,0.7-0.5,1c-0.2,0.3-0.5,0.5-0.9,0.7c-0.4,0.2-0.8,0.2-1.3,0.2h-2V274.6z M119.4,280.5 c0.3,0,0.6,0,0.9-0.1c0.3-0.1,0.6-0.2,0.8-0.5c0.2-0.2,0.4-0.5,0.6-0.9c0.1-0.4,0.2-0.8,0.2-1.4c0-0.4,0-0.8-0.1-1.1 c-0.1-0.3-0.2-0.6-0.3-0.8c-0.1-0.2-0.3-0.4-0.5-0.5c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.4-0.1-0.6-0.1c-0.2,0-0.4,0-0.5,0h-1.6 v5.6H119.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.1,274.6h0.4v2.8h4v-2.8h0.4v6.3h-0.4v-3.1h-4v3.1h-0.4V274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,274.6h4.2v0.3h-3.8v2.5h3.6v0.3h-3.6v2.8h3.9v0.3H133V274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.9,276.4c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.2-0.4-0.4-0.5c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.5-0.1-0.8-0.1 c-0.2,0-0.4,0-0.6,0.1c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.2,0.4-0.2,0.6c0,0.3,0.1,0.5,0.2,0.6 c0.1,0.2,0.3,0.3,0.5,0.4c0.2,0.1,0.4,0.2,0.7,0.2c0.3,0.1,0.5,0.1,0.8,0.2c0.3,0.1,0.5,0.1,0.8,0.2c0.3,0.1,0.5,0.2,0.7,0.3 c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.2,0.5,0.2,0.8c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.4,0.2-0.7,0.3 c-0.3,0.1-0.5,0.1-0.8,0.1c-0.4,0-0.7,0-1-0.1c-0.3-0.1-0.6-0.2-0.8-0.4c-0.2-0.2-0.4-0.4-0.6-0.7c-0.1-0.3-0.2-0.6-0.2-1h0.4 c0,0.3,0,0.6,0.1,0.9c0.1,0.2,0.3,0.4,0.5,0.6c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0.1,0.6,0.1,0.9,0.1c0.2,0,0.4,0,0.6-0.1 c0.2,0,0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.3,0.4-0.4c0.1-0.2,0.2-0.4,0.2-0.7c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.2-0.3-0.3-0.5-0.4 c-0.2-0.1-0.4-0.2-0.7-0.2c-0.3-0.1-0.5-0.1-0.8-0.2c-0.3-0.1-0.5-0.1-0.8-0.2c-0.3-0.1-0.5-0.2-0.7-0.3c-0.2-0.1-0.4-0.3-0.5-0.5 c-0.1-0.2-0.2-0.4-0.2-0.7c0-0.3,0.1-0.6,0.2-0.8c0.1-0.2,0.3-0.4,0.5-0.5c0.2-0.1,0.4-0.2,0.7-0.3c0.3-0.1,0.5-0.1,0.7-0.1 c0.3,0,0.6,0,0.9,0.1c0.3,0.1,0.5,0.2,0.7,0.3c0.2,0.2,0.4,0.4,0.5,0.6c0.1,0.2,0.2,0.5,0.2,0.9H143.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.3,274.6h0.4v6.3h-0.4V274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.6,280.5L152.6,280.5l2.2-5.9h0.4l-2.3,6.3h-0.4l-2.3-6.3h0.4L152.6,280.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.9,274.6h0.4l2.5,6.3h-0.4l-0.8-2h-3l-0.8,2h-0.4L158.9,274.6z M160.5,278.5l-1.3-3.5h0l-1.4,3.5H160.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.3,276.4c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.2-0.4-0.4-0.5c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.5-0.1-0.8-0.1 c-0.2,0-0.4,0-0.6,0.1c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.2,0.4-0.2,0.6c0,0.3,0.1,0.5,0.2,0.6 c0.1,0.2,0.3,0.3,0.5,0.4c0.2,0.1,0.4,0.2,0.7,0.2c0.3,0.1,0.5,0.1,0.8,0.2c0.3,0.1,0.5,0.1,0.8,0.2c0.3,0.1,0.5,0.2,0.7,0.3 c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.2,0.5,0.2,0.8c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.4,0.2-0.7,0.3 c-0.3,0.1-0.5,0.1-0.8,0.1c-0.4,0-0.7,0-1-0.1c-0.3-0.1-0.6-0.2-0.8-0.4c-0.2-0.2-0.4-0.4-0.6-0.7c-0.1-0.3-0.2-0.6-0.2-1h0.4 c0,0.3,0,0.6,0.1,0.9c0.1,0.2,0.3,0.4,0.5,0.6c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0.1,0.6,0.1,0.9,0.1c0.2,0,0.4,0,0.6-0.1 c0.2,0,0.4-0.1,0.6-0.2c0.2-0.1,0.3-0.3,0.4-0.4c0.1-0.2,0.2-0.4,0.2-0.7c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.2-0.3-0.3-0.5-0.4 c-0.2-0.1-0.4-0.2-0.7-0.2c-0.3-0.1-0.5-0.1-0.8-0.2c-0.3-0.1-0.5-0.1-0.8-0.2c-0.3-0.1-0.5-0.2-0.7-0.3c-0.2-0.1-0.4-0.3-0.5-0.5 c-0.1-0.2-0.2-0.4-0.2-0.7c0-0.3,0.1-0.6,0.2-0.8c0.1-0.2,0.3-0.4,0.5-0.5c0.2-0.1,0.4-0.2,0.7-0.3c0.3-0.1,0.5-0.1,0.7-0.1 c0.3,0,0.6,0,0.9,0.1c0.3,0.1,0.5,0.2,0.7,0.3c0.2,0.2,0.4,0.4,0.5,0.6c0.1,0.2,0.2,0.5,0.2,0.9H168.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogoRami);
export default __webpack_public_path__ + "static/media/footer-logo-rami.2112b411da0b4c05b042d120e79b302c.svg";
export { ForwardRef as ReactComponent };